<script lang="ts">
  export let textAlign: string = 'left';
  export let color: string = '#3D3D3D';
  export let component: string = 'p';
  export let href: string = '';

  const style = `
    text-align: ${textAlign};
    color: ${color};
  `;
</script>

{#if component === 'p'}
  <p on:click {style} class={$$props.class || ''}><slot /></p>
{:else if component === 'a'}
  <a {href} on:click {style} class={$$props.class || ''}><slot /></a>
{:else if component === 'span'}
  <span on:click {style} class={$$props.class || ''}><slot /></span>
{:else if component === 'h1'}
  <h1 on:click {style} class={$$props.class || ''}><slot /></h1>
{:else if component === 'h2'}
  <h2 on:click {style} class={$$props.class || ''}><slot /></h2>
{:else if component === 'h3'}
  <h3 on:click {style} class={$$props.class || ''}><slot /></h3>
{/if}
